<div
	[formGroup]="filterForm"
	class="overflow-y-auto h-full mt-24px pb-[100px] px-12px custom-filter"
>
	<div class="flex justify-between items-center">
		<h1 class="tw-font-bold mb-0 font-semibold text-[24px]">
			{{ 'GENERAL_LABELS.FILTRATION' | translate }}
		</h1>
		<button *ngIf="filterCount" (click)="resetFilter()" class="flex text-link">
			{{ 'ACTIONS.RESET' | translate }}
			<img
				class="align-middle mx-2"
				src="assets/images/icon-reset.svg"
				alt="icon"
			/>
		</button>
	</div>
	<div class="mt-24px">
		<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
			{{ 'GENERAL_LABELS.DATE_RANGES' | translate }}
		</p>
		<div class="flex gap-2 flex-row">
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('startDate')?.value"
				label="GENERAL_LABELS.START_DATE"
				(dateValue)="getController('startDate')?.setValue($event)"
			></app-custom-datepicker>
			<app-custom-datepicker
				class="w-[49%]"
				[defaultValue]="getController('endDate')?.value"
				label="GENERAL_LABELS.END_DATE"
				(dateValue)="getController('endDate')?.setValue($event)"
			></app-custom-datepicker>
		</div>

		<mat-error>
			<div
				class="whitespace-nowrap"
				*ngIf="
					getController('endDate')?.value < getController('startDate')?.value &&
					getController('endDate')?.value
				"
			>
				{{ 'VALIDATION.END_DATE_ERROR' | translate }}
			</div>
		</mat-error>

		<div class="w-100 h-[1px] bg-secondry-color-Gray my-16px"></div>
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'WALLET.WALLET_LIST.CLIENT' | translate }}
			</p>
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
				(click)="showClientList = !showClientList"
			>
				<mat-label>{{ 'GENERAL_LABELS.SEARCH_CLIENT' | translate }}</mat-label>
				<input type="text" matInput [formControl]="keywordClient" />
				<img
					*ngIf="!keywordClient?.value"
					class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
					src="assets/images/arrow.png"
				/>

				<img
					(click)="keywordClient.setValue('')"
					*ngIf="keywordClient?.value"
					src="./assets/images/close-square.svg"
					class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
				/>
			</mat-form-field>
			<ul class="autoCompleteList" *ngIf="showClientList">
				<li
					*ngFor="let name of clientList"
					(click)="
						showClientList = !showClientList;
						filterForm.controls['clientId'].setValue(name.id);
						keywordClient.setValue(name?.name);
						getClientList()
					"
				>
					{{ name?.name }}
				</li>
				<li *ngIf="!clientList?.length && showClientList" class="text-center">
					{{ 'GENERAL.NO_CLIENT_NAME_FOUND' | translate }}
				</li>
			</ul>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-16px"></div>
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'WALLET.WALLET_LIST.ORGSNAME' | translate }}
			</p>
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
				(click)="showList = !showList"
			>
				<mat-label>{{
					'GENERAL_LABELS.SEARCH_ORGSNAME' | translate
				}}</mat-label>
				<input type="text" matInput [formControl]="keyWord" />
				<img
					*ngIf="!keyWord?.value"
					class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
					src="assets/images/arrow.png"
				/>

				<img
					(click)="
						keyWord.setValue('');
						keyWordBranch.setValue('');
						filterForm.controls['serviceProviderId'].setValue(null);
						filterForm.controls['branchId'].setValue(null);
						branchesList = []
					"
					*ngIf="keyWord?.value"
					src="./assets/images/close-square.svg"
					class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
				/>
			</mat-form-field>
			<ul class="autoCompleteList" *ngIf="showList">
				<li
					*ngFor="let name of serviceProviders"
					(click)="
						filterForm.controls['serviceProviderId'].setValue(name.id);
						keyWord.setValue(name?.name);
						getBranches();
						showList = !showList
					"
				>
					{{ name?.name }}
				</li>
				<li *ngIf="!serviceProviders?.length && showList" class="text-center">
					{{ 'GENERAL.NO_BUSINESS_NAME_FOUND' | translate }}
				</li>
			</ul>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-16px"></div>
		<div>
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'BOOKING.BOOKING_DETAILS.BRANCH_NAME' | translate }}
			</p>
			<mat-form-field
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
				(click)="showBranchList = !showBranchList"
			>
				<mat-label>{{
					'GENERAL_LABELS.SEARCH_BRANCH_NAME' | translate
				}}</mat-label>
				<input type="text" matInput [formControl]="keyWordBranch" />
				<img
					*ngIf="!keyWordBranch?.value"
					class="w-3 cursor-pointer absolute ltr:right-6 rtl:left-6 top-[22px]"
					src="assets/images/arrow.png"
				/>

				<img
					(click)="keyWordBranch.setValue('')"
					*ngIf="keyWordBranch?.value"
					src="./assets/images/close-square.svg"
					class="cursor-pointer absolute ltr:right-4 rtl:left-4 top-[15px]"
				/>
			</mat-form-field>
			<ul class="autoCompleteList" *ngIf="showBranchList">
				<li
					*ngFor="let name of branchesList"
					(click)="
						filterForm.controls['branchId'].setValue(name.id);
						keyWordBranch.setValue(name?.name);
						getBranches();
						showBranchList = !showBranchList
					"
				>
					{{ name?.name }}
				</li>
				<li *ngIf="!branchesList?.length && showBranchList" class="text-center">
					{{ 'GENERAL.BRANCH_NAME_FOUND' | translate }}
				</li>
			</ul>
		</div>
		<div class="w-100 h-[1px] bg-secondry-color-Gray my-16px"></div>
		<div class="mt-[16px] mb-[30px]">
			<p class="text-[18px] ltr:font-DIN-Bold font-bold rtl:font-medium">
				{{ 'FINANCE.FINANCE_LIST.BOOKING_AMOUNT' | translate }}
			</p>
			<mat-radio-group
				aria-label="Select an option"
				formControlName="bookingCount"
			>
				<mat-radio-button
					(click)="
						fixed = true;
						ranged = false;
						getController('fromAmount').reset();
						getController('toAmount').reset()
					"
					[value]="0"
					class="ltr:mr-[24px] rtl:ml-[24px] text-font-14 text-dark-grey mb-5"
				>
					{{ 'FINANCE.FINANCE_LIST.FIXED' | translate }}</mat-radio-button
				>
				<br />
				<mat-radio-button
					(click)="
						fixed = false; ranged = true; getController('fixedAmount').reset()
					"
					class="text-font-14 text-dark-grey"
					[value]="1"
				>
					{{ 'FINANCE.FINANCE_LIST.RANGED' | translate }}</mat-radio-button
				>
			</mat-radio-group>
		</div>
		<div>
			<mat-form-field
				*ngIf="fixed"
				class="w-full mb-[30px]"
				appearance="outline"
			>
				<mat-label> {{ 'FINANCE.FINANCE_LIST.AMOUNT' | translate }}</mat-label>
				<input type="number" formControlName="fixedAmount" matInput />
				<mat-error>
					<validation-message
						[controller]="getController('fixedAmount')"
						controller_name="FINANCE.FINANCE_LIST.AMOUNT"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
			<div
				*ngIf="ranged"
				class="flex justify-center items-center mt-3"
				appearance="outline"
			>
				<mat-form-field class="w-[45%] mb-[30px]" appearance="outline">
					<mat-label> {{ 'FINANCE.FINANCE_LIST.MIN' | translate }}</mat-label>
					<input
						type="number"
						formControlName="fromAmount"
						[min]="1"
						matInput
					/>
					<mat-error>
						<validation-message
							[controller]="getController('fromAmount')"
							controller_name="FINANCE.FINANCE_LIST.MIN"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<span class="mx-[6px] mb-[30px]"></span>
				<mat-form-field
					*ngIf="ranged"
					class="w-[45%] mb-[30px]"
					appearance="outline"
				>
					<mat-label> {{ 'FINANCE.FINANCE_LIST.MAX' | translate }}</mat-label>
					<input
						(wheel)="$event.preventDefault()"
						type="number"
						[min]="+getController('fromAmount')?.value + 1"
						formControlName="toAmount"
						matInput
					/>
					<mat-error>
						<validation-message
							[controller]="getController('toAmount')"
							controller_name="FINANCE.FINANCE_LIST.MAX"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
			</div>
		</div>
		<button
			[disabled]="
				filterCount == 0 ||
				(ranged &&
					getController('fromAmount').value &&
					!getController('toAmount').value) ||
				(getController('endDate').value < getController('startDate').value &&
					getController('endDate').value)
			"
			class="bg-gradient text-white w-[89%] p-0 absolute bottom-2"
			mat-button
			(click)="submit()"
		>
			{{ 'ACTIONS.APPLY_FILTER' | translate }}
		</button>
	</div>
</div>
